import { Button, Typography } from "@material-ui/core";
import ActionDialogVariant from "@saleor/components/ActionDialogVariant";
import React, { FC } from "react";
import { FormattedMessage } from "react-intl";

import { useStyles } from "./styles";

interface IDeleteWarnDialogProps {
  isDialogShown: boolean;
  onClose: () => void;
  onDelete: () => void;
}

const DeleteWarnDialog: FC<IDeleteWarnDialogProps> = ({
  onClose,
  onDelete,
  isDialogShown
}) => {
  const classes = useStyles({});
  return (
    <ActionDialogVariant
      confirmButtonState="default"
      onClose={onClose}
      onConfirm={onDelete}
      open={isDialogShown}
      buttonsAlignment="center"
      maxWidth="sm"
      warningTitle="You are deleting this unlock code"
      variant="info"
      hideCancelButton
    >
      <Typography className={classes.subContent}>
        <FormattedMessage defaultMessage="Once removed, the deleted unlock code cannot be restored." />
      </Typography>
      <div className={classes.footerButtonsContainer}>
        <Button
          id="dialogRetainBtn"
          className={classes.retainButton}
          variant="contained"
          onClick={onClose}
        >
          Retain
        </Button>
        <Button
          id="dialogDeleteBtn"
          variant="contained"
          className={classes.deleteButton}
          onClick={onDelete}
        >
          Delete
        </Button>
      </div>
    </ActionDialogVariant>
  );
};

export default DeleteWarnDialog;
